function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.65 12c0 1-1.75 6.25-7.25 6.25S5.15 13 5.15 12 6.9 5.75 12.4 5.75 19.65 11 19.65 12Z",
    stroke: props.color,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.65 12a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z",
    stroke: props.color,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
export { SvgEye as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNSAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5LjY1IDEyQzE5LjY1IDEzIDE3LjkgMTguMjUgMTIuNCAxOC4yNUM2LjkwMDAyIDE4LjI1IDUuMTUwMDIgMTMgNS4xNTAwMiAxMkM1LjE1MDAyIDExIDYuOTAwMDIgNS43NSAxMi40IDUuNzVDMTcuOSA1Ljc1IDE5LjY1IDExIDE5LjY1IDEyWiIgc3Ryb2tlPSIjMTExMDEyIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNC42NSAxMkMxNC42NSAxMy4yNDI2IDEzLjY0MjcgMTQuMjUgMTIuNCAxNC4yNUMxMS4xNTc0IDE0LjI1IDEwLjE1IDEzLjI0MjYgMTAuMTUgMTJDMTAuMTUgMTAuNzU3NCAxMS4xNTc0IDkuNzUgMTIuNCA5Ljc1QzEzLjY0MjcgOS43NSAxNC42NSAxMC43NTc0IDE0LjY1IDEyWiIgc3Ryb2tlPSIjMTExMDEyIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";